import { AppState } from '../../../../redux/reducers';
import * as Store from '../../../../redux/middleware/ContractConceptCategoryMiddleware';
import { ContractConceptCategory } from '../../../../models/Entities/Contracts/ContractConceptCategory';

export interface IProps {
    /** Ids (o categorías) seleccionadas. Con `MultiselectEnable` en false se toma la primera. */
    SelectedCategories?: Array<number | ContractConceptCategory>;
    onSelectedCategories: (categories: ContractConceptCategory[]) => void;
    MultiselectEnable?: boolean;
    label?: string;
    /** Sin etiqueta: el contexto ya dice qué es (por ejemplo dentro de una fila). */
    showLabel?: boolean;
    hint?: string;
    required?: boolean;
    errorMessage?: string;
    disabled?: boolean;
    /** Botón de engranaje que abre el drawer de administración. */
    showManageButton?: boolean;
    /**
     * La lista desplegable se dibuja en el lugar y no en un portal. Hace falta
     * dentro de un popover: un clic en el portal cuenta como "afuera" y lo cierra
     * antes de que la opción se registre.
     */
    inlineList?: boolean;
}

interface ConnectedProps {
    Categories: ContractConceptCategory[];
    isLoading: boolean;
    hasLoaded: boolean;
    failOnLoading: boolean;
}

interface DispatchProps {
    GetAllContractConceptCategories: typeof Store.actionCreators.GetAllContractConceptCategories;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState): ConnectedProps => ({
    Categories: state.ContractConceptCategories?.list ?? [],
    isLoading: state.ContractConceptCategories?.isLoadingAll ?? false,
    hasLoaded: state.ContractConceptCategories?.successLoadingAll === true,
    failOnLoading: state.ContractConceptCategories?.failOnLoadingAll ?? false
});

export const mapDispatchToProps = {
    GetAllContractConceptCategories: Store.actionCreators.GetAllContractConceptCategories
};

/** Convierte lo que llega en props (ids o entidades) a las categorías del store. */
export const resolveSelected = (
    selected: Array<number | ContractConceptCategory> | undefined,
    categories: ContractConceptCategory[]
): ContractConceptCategory[] => {
    if (!selected || selected.length === 0) return [];
    const result: ContractConceptCategory[] = [];
    selected.forEach((item) => {
        const id = typeof item === 'number' ? item : item.id;
        const found = categories.find((category) => category.id === id) ?? (typeof item === 'number' ? undefined : item);
        if (found && !result.some((existing) => existing.id === found.id)) result.push(found);
    });
    return result;
};
